import { createAsyncThunk } from "@reduxjs/toolkit";
import { http } from "../../../utils/config";
export const getListGroupCustomer = createAsyncThunk(
  "groupCustomer/getListGroupCustomer",
  async ({ currentPage, pageSize, branchId }, { rejectWithValue }) => {
    try {
      let apiUrl = `/mcoupon/api/v1/group-customers?has_paginate&size=${pageSize}&page=${currentPage}`;
      if (branchId) apiUrl += `&branch_id=${branchId}`;
      const response = await http.get(apiUrl);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);
export const getListGroupCustomerALl = createAsyncThunk(
  "groupCustomer/getListGroupCustomerALl",
  async (value) => {
    try {
      const apiUrl =
        value === undefined
          ? "/mcoupon/api/v1/group-customers"
          : `/mcoupon/api/v1/group-customers?branch_id=${value}`;
      const response = await http.get(apiUrl);
      return response.data;
    } catch (error) {
      // return rejectWithValue(error.response.data);
    }
  }
);

export const getGroupCustomerById = createAsyncThunk(
  "groupCustomer/getGroupCustomerById",
  async (id, { rejectWithValue }) => {
    try {
      const response = await http.get(`/mcoupon/api/v1/group-customers/${id}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data);
    }
  }
);

// Lấy khách theo đơn vị — server-side search + phân trang (pool chọn thành viên)
export const getCustomersByBranch = createAsyncThunk(
  "groupCustomer/getCustomersByBranch",
  async ({ branchId, search, page = 1, size = 10 }, { rejectWithValue }) => {
    try {
      let url = `/mcoupon/api/v1/customer/getList?has_paginate&light=1&branch_id=${branchId}&page=${page}&size=${size}`;
      if (search) url += `&search=${encodeURIComponent(search)}`;
      const response = await http.get(url);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data);
    }
  }
);

export const createGroupCustomer = createAsyncThunk(
  "groupCustomer/createGroupCustomer",
  async (data, { rejectWithValue }) => {
    try {
      const response = await http.post(`/mcoupon/api/v1/group-customers`, data);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);
export const deleteGroupCustomer = createAsyncThunk(
  "groupCustomer/deleteGroupCustomer",
  async (id, { rejectWithValue }) => {
    try {
      const response = await http.delete(
        `/mcoupon/api/v1/group-customers/${id}`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const editGroupCustomer = createAsyncThunk(
  "groupCustomer/editGroupCustomer",
  async (data, { rejectWithValue }) => {
    try {
      const response = await http.put(
        `/mcoupon/api/v1/group-customers/${data.id}`,
        {
          name: data.name,
          branch_id:data.branch_id,
          customer_id: data?.customer_id,
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);
